module.exports = __webpack_public_path__ + "static/default-blog-9495f7ea0a68d042c4330be137f48e1e.webp";